module.exports = __webpack_public_path__ + "images/apple-touch-icon.png";